import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'nameDotten'
})
export class NameDottenPipe implements PipeTransform {

  transform(value: string): string {
    const result = value.split(' ');
    if (result.length > 1) {
      result.forEach((e, index) => {
        if ( (index + 1) < result.length) {
          result[index] = e[0] + '.';
        }
      });
      return result.join(' ');
    }
    return value;
  }

}
